import { fetchBasicJsonPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };

        parameters.account = filter.account || null;
        parameters.subAccount = filter.subAccount || null;
        parameters.account1 = filter.account1 || null;
        parameters.subAccount1 = filter.subAccount1 || null;
        parameters.name = filter.name || null;

        return fetchBasicJsonPostJson('/Accounting/GetDataTableData', {
            data: parameters,
            signal: signal
        },
        {
            useBlock: !signal
        });
    },
    add: item => {
        return fetchBasicJsonPost('/Accounting/Add', {
            data: item
        });
    },
    edit: item => {
        return fetchBasicJsonPost('/Accounting/Modify', {
            data: item
        });
    }
};
